export default __webpack_public_path__ + "static/media/culture-icon1.dfcd3768.svg";